<template>
  <img :src="logoUrl" :alt="altText" :style="{ width: computedWidth }" />
</template>

<script>
export default {
  props: {
    // Prop to allow width customization
    width: {
      type: String,
      default: '180px'
    },
    // Optional prop for alt text
    altText: {
      type: String,
      default: 'Balan.AI Logo'
    }
  },
  data() {
    return {
      // The URL to the logo in the public directory
      logoUrl: '/logo.png'
    };
  },
  computed: {
    computedWidth() {
      // Use the prop value if provided, otherwise default
      return this.width;
    }
  }
};
</script>

<style scoped>
img {
  height: auto; /* Maintain aspect ratio */
}
</style>
